module.exports = __webpack_public_path__ + "static/gilly_groupie_4-64e00c22c56d30b387b90c80be8639cd.jpg";